export const universalSearchClass = 'universal-search';

export const focusUniversalSearch = () => {
  const element: HTMLElement | null = document.querySelector(`.${universalSearchClass} input`);
  element?.focus();
};
